import { resolveReference } from '@/utils/lib/resolve-reference';
import type { SecondaryLink } from '@/components/organisms/jaycar-header/types';
import type { LinkReference } from '../types';

// Map the Header tastic's Studio `secondaryLinks` group into the flat
// {label, href} shape the Products slide-out renders. Mirrors the existing
// `pageLinks` mapping in the tastic.
const mapSecondaryLinks = (links: LinkReference[]): SecondaryLink[] =>
  links.map((link) => ({
    label: link.name ?? '',
    href: resolveReference(link.href).href ?? '/',
  }));

export default mapSecondaryLinks;
